import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const fetch = ({
    userId,
}) => {
    return axios.get(urlGenerator.userInterests(userId), createRequestConfig()).then(property('data'))
}

const update = ({
    userId,
    interestIds = [],
}) => {
    return axios.post(urlGenerator.userInterests(userId), { interests: interestIds }, createRequestConfig()).then(property('data'))
}

export default {
    fetch,
    update,
}